import { render, staticRenderFns } from "./AppSetting.vue?vue&type=template&id=32f3706d&"
import script from "./AppSetting.vue?vue&type=script&lang=js&"
export * from "./AppSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports